export default __webpack_public_path__ + "static/media/1.c9b76938.png";